<template>
	<div class="mybook">
		<div class="book-show">
			<div class="book-detail" v-for="(item,index) in boolist" v-if="index<3" :key="index">
				<div>
					<!-- <img :src="imgurl + item.converPath" alt="" style="box-shadow: 3px 3px 5px #ccc;"> -->
					<el-image class="work-image" fit="fill" :src="baseApi +'/' + item.converPath"
						lazy >
						<img slot="error" src="../assets/img/defaultBg.png" fit="fill" style="height: 155px;"/>
					</el-image>
				</div>
				<div >
					<div class="title">
						{{item.worksName}}
					</div>
					<div class="read">
						Word count:{{wordsFormate(item.words)}}
					</div>
					<div class="Divider"></div>
					<div class="date">
						<div>
							<p>{{changedate(item.createDateTime)}}</p>
							<div class="at">Created on</div>
						</div>
						<div class="middle"></div>
						<div >
							<p>{{changedate(item.signTime)}}</p>
							<div class="at">Signed on</div>
						</div>
					</div>
					<div class="bottom">
						<div class="type">Contact type</div>
						<div class="percentage">{{screen(item.incomeType,item.dividePrecent)}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				boolist:[],
				imgurl: 'https://gw-reader.com:4001/',
				baseApi: process.env.VUE_APP_NOVEL_API,
			}
		},
		props:{
			booklist:Array
		},
		created(){
			this.boolist = this.booklist
		},
		methods:{
			wordsFormate(value){//大于100的用K为单位
				if(value>=100){
					//保留两位小数，不用四舍五入法
					let formatework=Math.floor(value/1000*10)/10
					var workstr= formatework +"K"
					return workstr
				}
				return value
				
			},
			//修改时间样式
			formatDate(Time) { //获得UTC的时间
				const moment = require('moment-timezone');
				if (Time == null) {
					return null
				}
				var timezone = "Asia/Shanghai";
				const clean = moment(Time).format('MM-DD-YYYY'); // 清除 timezone 信息
				const Shanghailocal = moment.tz(clean, timezone);
				return Shanghailocal.tz('UTC').format('MM-DD-YYYY')
			},
			//签约类型
			screen(incomeType,dividePrecent){
				if(incomeType===null){
					//不转换
				} else {
					incomeType  = incomeType.toString()
				}
				// val = val.toString()
				switch(incomeType){
					case '100':
					    if(dividePrecent>0){
							incomeType = "ex " + dividePrecent + '%'
						} else{
							incomeType = 'ex'
						}
						return incomeType
						break;
					case '200':
						if(dividePrecent>0){
							incomeType = "ex " + dividePrecent + '%'
						} else{
							incomeType = 'ex'
						}
						return incomeType
						break;
					case '101':
						if(dividePrecent>0){
							incomeType = "ex " + dividePrecent + '%'
						} else{
							incomeType = 'ex'
						}
						return incomeType
						break;
					case '201':
						if(dividePrecent>0){
							incomeType = "ex " + dividePrecent + '%'
						} else{
							incomeType = 'ex'
						}
						return incomeType
						break;
					case '300':
						if(dividePrecent>0){
							incomeType = "ex " + dividePrecent + '%'
						} else{
							incomeType = 'ex'
						}
						return incomeType
						break;
					default:
						if(dividePrecent>0){
							incomeType = "non-ex " + dividePrecent + '%'
						} else{
							incomeType = 'non-ex '
						}
						return incomeType
						break;

				}
			
			},
		datescreen(name){
			switch(name){
				case '01':
					return 'Jan'
					break;
				case '02':
					return 'Feb'
					break;
				case '03':
					return 'Mar'
					break;
				case '04':
					return 'Apr'
					break;
				case '05':
					return 'May'
					break;
				case '06':
					return 'Jun'
					break;
				case '07':
					return 'Jul'
					break;
				case '08':
					return 'Aug'
					break;
				case '09':
					return 'Sep'
					break;
				case '10':
					return 'Oct'
					break;
				case '11':
					return 'Nov'
					break;
				case '12':
					return 'Dec'
					break;
			}
		},
		changedate(val){
			val = this.formatDate(val)
			//替换指定位置的字符
			const replaceStr = (str, index, char) => {
			 return str.substring(0, index) + char + str.substring(index + 2);
			}
			if(val == null || val==""){
				//不执行
			} else {
				let aa = this.datescreen(val.slice(0,2))
				val = replaceStr(val.toString(),0,aa)
			}
			
			return val
		}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.mybook{
		.book-show{
			display: flex;
			// flex-direction: row;
			// justify-content: space-around;
			flex-wrap: wrap;
			width: 50%;
			.book-detail{
				width: 30%;
				background-color: white;
				position: relative;
				box-shadow: 0px 1px 4px rgba(0,0,0,0.3),0px 0px 50px white inset;
				border-radius: 10px;
				margin: auto;
				margin-top: 60px;
				// height: 300px;
				.work-image{
					position: absolute;
					left: 50%;
					margin-left: -50px;
					margin-top: -35px;
					width: 100px;
					height: 120px;
					box-shadow: 3px 3px 5px #ccc;
				}
				img{
					position: absolute;
					left: 50%;
					margin-left: -50px;
					margin-top: -35px;
					width: 100px;
					height: 120px;
				}
				.title{
					padding-top: 100px;
					text-align: center;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
					word-break: keep-all;
					// width: 150px;
					// width: 50vw;
					word-wrap: break-word;
				}
				.read{
					text-align: center;
					// padding-top: 10px;
					font-size: 10px;
					// ''color: #CCC;
				}
				.Divider{
					border:1px solid whitesmoke;
					margin: 35px 10px 10px 10px;
				}
				.date{
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					padding: 0px 20px 20px 20px ;
					.middle{
						border-left: 3px solid whitesmoke;
					}
					.at{
						// font-size: 5px;
						text-align: center;
					}
				}
				.bottom{
					background-color: #e8f0fd;
					display: flex;
					margin: 0px 10px 10px 10px;
					padding:5px 5px;
					border-radius: 5px;
					.type{
						padding-left: 5px;
					}
					.percentage{
						color: black;
						font-size: 15px;
						font-weight: 600;
						padding-left: 10px;
					}
				}
			}
		}
	}
</style>